import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";

export const MealTime = (props) => {
  const data = {
    title: "When do you usually have first meal?",
    list: [{
      content: "Between 6 and 8 am",
    },{
      content: "Between 8 and 10 am",
    },{
      content: "Between 10 am and noon",
    },{
      content: "I usually skip breakfast",
    },]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect list={data} {...props} />
    </div>
  );
};
